"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickItemToExpandInteractionManager = void 0;
var types_1 = require("../types");
var isControlKey_1 = require("../isControlKey");
var utils_1 = require("../utils");
var ClickItemToExpandInteractionManager = /** @class */ (function () {
    function ClickItemToExpandInteractionManager(environment) {
        this.mode = types_1.InteractionMode.ClickItemToExpand;
        this.environment = environment;
    }
    ClickItemToExpandInteractionManager.prototype.createInteractiveElementProps = function (item, treeId, actions, renderFlags) {
        var _this = this;
        return {
            onClick: function (e) {
                actions.focusItem();
                if (e.shiftKey) {
                    actions.selectUpTo(!e.ctrlKey);
                }
                else if ((0, isControlKey_1.isControlKey)(e)) {
                    if (renderFlags.isSelected) {
                        actions.unselectItem();
                    }
                    else {
                        actions.addToSelectedItems();
                    }
                }
                else {
                    if (item.isFolder) {
                        actions.toggleExpandedState();
                    }
                    actions.selectItem();
                    if (!item.isFolder ||
                        _this.environment.canInvokePrimaryActionOnItemContainer) {
                        actions.primaryAction();
                    }
                }
            },
            onFocus: actions.focusItem,
            onDragStart: function (e) {
                e.dataTransfer.dropEffect = 'move'; // TODO
                // e.dataTransfer.setDragImage(environment.renderDraggingItem(viewState.selectedItems), 0, 0);
                actions.startDragging();
            },
            onDragOver: utils_1.preventDefault,
            draggable: renderFlags.canDrag && !renderFlags.isRenaming,
            tabIndex: !renderFlags.isRenaming
                ? renderFlags.isFocused
                    ? 0
                    : -1
                : undefined,
        };
    };
    return ClickItemToExpandInteractionManager;
}());
exports.ClickItemToExpandInteractionManager = ClickItemToExpandInteractionManager;
